module.exports = __webpack_public_path__ + "static/img/btn5.2a8da542.png";